module.exports = __webpack_public_path__ + "static/media/fresh-factory-img7.ea4bc8d7.png";